const state = {
  registerTemporary: {},
  forgotPasswordTemporary:{}
};

const getters = {
  registerTemporary: (state) => state.registerTemporary,
  forgotPasswordTemporary: (state) => state.forgotPasswordTemporary,
};

const actions = {};

const mutations = {
  updateRegisterTemporary: (state, data) => (state.registerTemporary = data),
  updateForgotPasswordTemporary: (state, data) => (state.forgotPasswordTemporary = data),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
